import React from 'react';
import 'twin.macro';

import Button from 'components/button/Button';
import { Modal } from 'components/page/app-page/Modal';
import Budget from 'components/payment/Budget';
import { useBudgetModal } from 'components/payment/useBudgetModal';

/**
 * SYM-6583: the Start Campaign button for a stopped campaign whose budget is used up.
 * It opens the budget window (account balance ticked when there is balance) instead of
 * being greyed out. Paying the extra budget restarts the campaign on the server.
 */
const RestartWithBudgetButton: React.FC<{
  onBudgetAdded: () => void | Promise<void>;
}> = ({ onBudgetAdded }) => {
  const budgetModal = useBudgetModal();

  return (
    <div tw="h-full flex flex-col justify-center mr-auto">
      <Modal
        show={budgetModal.isOpen}
        onClose={budgetModal.dismiss}
        hideCloseButton={budgetModal.isSubmitting}
      >
        <Budget
          title="Add budget to restart your campaign"
          subtitle="This campaign has used its whole budget. Add budget and it starts again."
          cta="Add budget and restart"
          closeModal={budgetModal.complete}
          onSubmittingChange={budgetModal.onSubmittingChange}
          isSubmitting={budgetModal.isSubmitting}
          onSubmit={onBudgetAdded}
        />
      </Modal>
      <Button
        id="restart-campaign-with-budget"
        variant="secondary"
        onClick={budgetModal.open}
        disabled={budgetModal.isSubmitting}
      >
        Start Campaign
      </Button>
    </div>
  );
};

export default RestartWithBudgetButton;
